import { authCheck, capitalizeFirstLetter, extractOptionFromBC, getCookie, setCookie } from "../../common/utils";
import config from "../../../config";

export const generateCollections = (menu_item) => {
    return menu_item && menu_item.collections_filter_key ? extractOptionFromBC(menu_item.collections_filter_key) : [];
};

export const generateCollectionPrefix = (collection) => {
    return collection && collection.prefix ? collection.prefix.replace(/\\/g, "") : "";
};

export const generateExtra = (menu_item) => {
    return menu_item && menu_item.extra_filter_key ? extractOptionFromBC(menu_item.extra_filter_key) : [];
};

export const generateExtraPrefix = (extra) => {
    return extra && extra.prefix ? extra.prefix.replace(/\\/g, "") : "";
};

export const mapSearchSuggestions = (suggestedSearchTerms, searchProductResults, filterOptions) => {
    const mapTopMatches = [...searchProductResults];
    const mapDesignerCollections = suggestedSearchTerms ? [...suggestedSearchTerms] : [];
    let noFilterOptionValueFound = false;
    let filterGroupParam;

    mapTopMatches.forEach((topMatch) => {
        const condition = topMatch.metafields.filter(metafield => metafield.key === 'condition')[0];
        topMatch.image_url = topMatch.images[1];
        topMatch.product_url = `${config.host_rebag_shop}/products/${topMatch.handle}`;
        topMatch.condition = condition ? condition.value : null;
        topMatch.price = topMatch.price_max;
        topMatch.designer = topMatch.vendor;
    })

    mapDesignerCollections.forEach((collection => {
        let filterPrefix = '';
        const noTagsTitle = collection.title.replace(/<(.|\n)*?>/g, '');
        let noTagsTitleEncoded;
        let exitLoop = false;

        filterOptions.some(filterBlock => {
            if (filterBlock.status === 'active') {
                filterGroupParam = filterBlock.filterOptionId;
                exitLoop = filterBlock.values.some((filterBlockOption => {
                    if (filterBlock.prefix) {
                        filterPrefix = filterBlock.prefix.replace(/\\/g, '');
                    } else {
                        filterPrefix = '';
                    }
                    if(filterBlockOption.key === filterPrefix + noTagsTitle) {
                        noTagsTitle.replace(/\w\S*/g, function(txt){
                            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                        });
                        noTagsTitleEncoded = encodeURIComponent(filterPrefix + noTagsTitle);
                        noFilterOptionValueFound = false;
                        return true;
                    }
                }))
            }
            if (exitLoop) return true;
        })

        if (noTagsTitleEncoded && noFilterOptionValueFound === false) {
            collection.search_url = `/collections/new-arrivals?_=pf&pf_st_availability_hidden=true&${filterGroupParam}=${noTagsTitleEncoded}`
        } else {
            noFilterOptionValueFound = false;
            collection.search_url = `/collections/${collection.handle}`
        }
    }))

    return {mapTopMatches, mapDesignerCollections}
}

export const sendGroupBySearchEvent = (searchValue, searchProductResults, nonUsd) => {
    if (searchProductResults.length > 0) {
        const productUrls = [];
        searchProductResults.forEach(product => {
            productUrls.push({_u: product.id});
        })
        if (window.gbTracker) {
            window.gbTracker.sendSearchEvent({
                "search": {
                    "query": searchValue,
                    "originalQuery": searchValue,
                    "correctedQuery": searchValue,
                    "totalRecordCount": searchProductResults.length,
                    "pageInfo": {
                        "recordStart": 1,
                        "recordEnd": searchProductResults.length
                    },
                    "selectedNavigation": [
                        {
                            "name": '',
                            "displayName": '',
                            "refinements": [
                                {
                                    "type": 'Value',
                                    "value": '',
                                }
                            ],
                        }
                    ],
                    "records": productUrls,
                    "origin": {
                        "search": true,
                        "recommendations": false,
                        "dym": false,
                        "sayt": false,
                        "navigation": false,
                    }
                },
                "experiments": [
                    {
                        "experimentId": "GroupByTest",
                        "experimentVariant": "GroupBy"
                    }
                ]
            });
            window.dataLayer.push({
                'event': 'api_provider',
                'type': 'search_query',
                'value': 'GroupBy',
                'non_USD': nonUsd,
            });
        }
    }
}

export const mapRecentSearches = (recentSearches) => {
  const mappedRecentSearches = [];
  recentSearches.forEach(searchTerm => {
      const mapSearch = {};
      const capitalizeWordsString = searchTerm.title.split(' ');
      capitalizeWordsString.forEach((string, index) => capitalizeWordsString[index] = capitalizeFirstLetter(string));
      mapSearch.title = capitalizeWordsString.join(' ');
      mapSearch.search_url = searchTerm.search_url;
      mappedRecentSearches.push(mapSearch);
  })
    return mappedRecentSearches
}

export const mapGroupBySearch = (searchTerms, products) => {
  const mappedSuggestedSearches = [...searchTerms];
  const mappedProducts = [...products];
    mappedSuggestedSearches.forEach(searchTerm => {
    searchTerm.search_url = `/search?q=${searchTerm.value}`;
    const capitalizeWordsString = searchTerm.value.split(' ');
    capitalizeWordsString.forEach((string, index) => capitalizeWordsString[index] = capitalizeFirstLetter(string));
    searchTerm.title = capitalizeWordsString.join(' ');
  })
    mappedProducts.forEach(topMatch => {
      topMatch.image_url = topMatch.image;
      topMatch.product_url = `${config.host_rebag_shop}/products/${topMatch.handle}`;
      topMatch.condition = topMatch.condition_label || null;
      topMatch.designer = topMatch.vendor;
  })
    return {mappedSuggestedSearches, mappedProducts}
}

export const mapGroupBySearchOld = (searchTerms, searchTopMatches) => {
    const mappedSearchTerms = [...searchTerms];
    const mappedSearchTopMatches = [...searchTopMatches];
    mappedSearchTerms.forEach(searchTerm => {
        searchTerm.search_url = `/search?q=${searchTerm.value}`;
        const capitalizeWordsString = searchTerm.value.split(' ');
        capitalizeWordsString.forEach((string, index) => capitalizeWordsString[index] = capitalizeFirstLetter(string));
        searchTerm.title = capitalizeWordsString.join(' ');
    })
    mappedSearchTopMatches.forEach(topMatch => {
        topMatch.image_url = topMatch.image;
        topMatch.product_url = `${config.host_rebag_shop}/products/${topMatch.handle}`;
        topMatch.condition = topMatch.condition_label || null;
        topMatch.designer = topMatch.vendor;
    })
    return {mappedSearchTerms, mappedSearchTopMatches}
}

export const setRecentSearch = (searchValue) => {
    const search_url = `/search?q=${searchValue}&pf_st_availability_hidden=true`
    const recentSearches = getCookie('recentSearches');
    if (recentSearches) {
        setCookie('recentSearches', JSON.stringify([{title: searchValue, search_url}, ...(JSON.parse(recentSearches).filter(s => s.title.toLowerCase() !== searchValue.toLowerCase()).slice(0, 7)),]) , 1000);
    } else {
        setCookie('recentSearches', JSON.stringify([{title: searchValue, search_url}]), 1000);
    }
}

export const filterForYouMenuItemForNoLoggedInUser = (menuItem) => {
    return !(menuItem.key === 'for_you' && !authCheck());
}